// ── Bangkok wall-clock helpers, shared by Snooze (EmailDetail) and Schedule send (composers) ──────
// The office lives in Asia/Bangkok (UTC+7, no DST); presets and the date-time box are expressed in
// that wall clock whatever the browser's zone, and stored as real moments (ms / unix seconds).
export const BKK_OFFSET_MS = 7 * 3600_000;

/** Today's Bangkok date + `days`, at hour:minute Bangkok → the real moment (ms). */
export function bkkAt(days: number, hour: number, minute = 0): number {
  const b = new Date(Date.now() + BKK_OFFSET_MS);   // its UTC fields read as Bangkok wall-clock
  return Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate() + days, hour, minute) - BKK_OFFSET_MS;
}
/** Bangkok day of week (0 = Sunday) and hour right now. */
export const bkkNow = () => { const b = new Date(Date.now() + BKK_OFFSET_MS); return { dow: b.getUTCDay(), hour: b.getUTCHours() }; };

/** Bangkok day, date and time in the interface language; English is UK day-first, e.g. "Fri 25 Sept, 08:00". */
export const fmtBkk = (ms: number, lang: string) => new Date(ms).toLocaleString(lang === 'zh' ? 'zh-CN' : lang === 'th' ? 'th-TH' : 'en-GB',
  { timeZone: 'Asia/Bangkok', weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } as Intl.DateTimeFormatOptions);

/** The date-time box works in Bangkok time: 'YYYY-MM-DDTHH:mm' ⇄ the real moment (ms; NaN = incomplete). */
export const toBkkInput = (ms: number) => new Date(ms + BKK_OFFSET_MS).toISOString().slice(0, 16);
export const fromBkkInput = (v: string): number => {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(v);
  return m ? Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) - BKK_OFFSET_MS : NaN;
};
